import { getMatchScore, tokenMatch } from '../../../utils/listSearch'

import { getSearchableString } from './hotelSelectorHelpers'
import { Subsidiary } from './Subsidiary'

export const HotelSelectorGroup = ({
  groupName,
  formattedSubsidiaries,
  searchParam,
  handleSelect,
  isInternalAdmin
}) => {
  if (!formattedSubsidiaries?.[groupName]) return null

  let filteredHotels = formattedSubsidiaries[groupName].filter(h => {
    if (searchParam.length === 36 && searchParam.includes('-')) {
      return h.subsidiaryId === searchParam
    }
    const searchableString = getSearchableString(h, groupName)
    return tokenMatch(searchParam, searchableString)
  })

  const isSearchMode =
    searchParam.trim() !== '' && !(searchParam.length === 36 && searchParam.includes('-'))
  if (isSearchMode && filteredHotels.length > 1) {
    filteredHotels = [...filteredHotels].sort((a, b) => {
      const scoreA = getMatchScore(searchParam, getSearchableString(a, groupName))
      const scoreB = getMatchScore(searchParam, getSearchableString(b, groupName))
      return scoreB - scoreA
    })
  }

  return (
    <div key={groupName}>
      {groupName !== 'parentless' && filteredHotels && filteredHotels.length > 0 ? (
        <div className="hotel-selector__group-name">{groupName}</div>
      ) : null}
      {filteredHotels.map(hotel => (
        <Subsidiary
          key={hotel.subsidiaryId}
          hotel={hotel}
          groupName={groupName}
          searchParam={searchParam}
          handleSelect={handleSelect}
          isInternalAdmin={isInternalAdmin}
        />
      ))}
    </div>
  )
}
